var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.$t('landingSignUp.downloadLink')}},[_c('div',[(_vm.store === 'google')?_c('img',{attrs:{"alt":"Get it on Google Play","src":require("@/assets/img/play-store-badge.png")}}):(_vm.store === 'apple')?_c('img',{attrs:{"alt":"Get it on App store","src":require("@/assets/img/app-store-badge.png")}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }